import { useStores } from "stores/root-store"
import { storageName } from "shared/constants/storage-constant"
import { formatDisplayDateTime } from "utils/date-helper"
import { rootStore } from "stores/root-store"
import { useEffect } from "react"
import CommonPage from "components/common/common-page"

const Return = () => {
  const { ReturnStore } = useStores()

  const filterData = [
    {
      name: "before_date",
      text: "Before Date",
      checked: true,
    },
    {
      name: "after_date",
      text: "After Date",
      checked: true,
    },
    {
      name: "return_receipt_type",
      text: "Receipt Type",
    },
  ]

  const hiddenColumns = {
    RETURN_ACTION: false,
    RETURN_REASON: false,
    RECEIPT_TYPE: false,
    WAREHOUSE: false,
  }

  const columns = [
    {
      field: "RECEIPT_ID",
      headerName: "Receipt ID",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "CUSTOMER_NAME",
      headerName: "Customer",
      width: 150,
    },
    {
      field: "PRODUCT",
      headerName: "Product",
      width: 150,
    },
    {
      field: "RECEIVED_QTY",
      headerName: "Qty",
      width: 80,
    },
    {
      field: "COMPANY",
      headerName: "Company",
    },
    {
      field: "WAREHOUSE",
      headerName: "Destination Warehouse",
    },
    {
      field: "RECEIPT_TYPE",
      headerName: "Receipt Type",
    },
    {
      field: "ORIGINAL_SKU",
      headerName: "Original SKU",
      minWidth: 150,
      flex: 1,
    },
    {
      field: "LPN",
      headerName: "LPN",
      width: 130,
    },
    {
      field: "ORDER_REFERENCE",
      headerName: "Order Reference",
      width: 150,
    },
    {
      field: "CLOSE_DATE",
      headerName: "Close date",
      width: 150,
      renderCell: params => {
        return formatDisplayDateTime(params.value)
      },
    },
    {
      field: "RETURN_REASON",
      headerName: "Return Reason",
    },
    {
      field: "RETURN_ACTION",
      headerName: "Return Action",
    },
  ]

  useEffect(() => {
    rootStore.setScreenTitle("Return Search")
    return () => rootStore.setScreenTitle("")
  }, [])

  return (
    <CommonPage
      DataStore={ReturnStore}
      filterData={filterData}
      searchPlaceholder={"Search by Receipt ID, Tracking Number, ERP Number, or Supplier."}
      filterStorageName={storageName.returnsFilter}
      allowArchivalSearch={true}
      columns={columns}
      hiddenColumns={hiddenColumns}
      gridStorageName={storageName.returnsColumn}
      searchRequiredWarningMsg="Search for a specific return and select a filter to narrow down your search"
      noDataMsg="Your search returned no results. Please contact ops@estorelogistics.com.au if you believe this error is incorrect."
      exportFileName="Express_Return"
      idProp={"key"}
    />
  )
}

export default Return
